import * as user from "./user"
import * as location from "./location"

/* Configure reusable business logic hooks */
export const userLogic = user
export const locationLogic = location
